import React, { Component } from 'react';
import Canvas from "./Canvas"
class Achievements extends Component {
    render() {
        return (
            <div className="App">
            <h2>PUBLICATIONS</h2>
            <a href="http://apadivision16.org/wp-content/uploads/2021/03/TSP-Spring-2021.pdf#page=21" target="_blank">
              <h4>How To Be Anti-Racist: A School Psychology Starter Pack</h4>
            </a>
            <a href="https://outerplaces.tumblr.com/" target="_blank">
              <h4>Outer Places Social Media Page</h4>
            </a>
            <h5>Outer Places is no longer online, but you can check out this  <a href="https://web.archive.org/web/20150630183736/http://www.outerplaces.com/tag?tag=Technology" target="_blank">
              web archive
            </a> to see some of the technology articles I wrote in 2015</h5>
          </div>
            )}
}
export default Achievements 